export default __webpack_public_path__ + "icon1_14x14 blue.1e47b300dbff070ed046.png";